// deps
// eslint-disable-next-line import/no-unresolved
import generateUri from "@splitfire-agency/raiden-library/dist/libraries/RouterImplementation/generateUri";

// constants
import apiRouter from "../../../constants/routers/api";

/**
 * Retourne l’URI de la route API demandée.
 * @return {string}
 */
export default function generateApiUri(param0) {
  return generateUri({
    router: apiRouter,
    ...param0,
  });
}
